export const LOCALFORAGE_KEYS = {
  latestScrollPosition: 'latestScrollPosition',
};



// WEBPACK FOOTER //
// ./app/UI/constants.js